import { GuardedComponent } from '../components/guarded-component';
import { WorkOrderReportPage } from '../features/work-order-report/work-order-report.page';
import { UserPermissionName } from '../models/user-permission-name';

export const WorkorderReportRoute = {
  path: '/workorder-reports',
  name: 'Work Order Reports',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_WORKORDER_REPORTS]} showPermissionError>
          <WorkOrderReportPage />
        </GuardedComponent>
      ),
    },
  ],
};
